import type * as C from '../../../../packages/domain/src/community-admin';
export function fixtures(projectId?: string) {
  const now = Date.now(),
    day = 86400000;
  const people: C.CommunityPerson[] = [
    'Amira Mansour',
    'Leo Martin',
    'Nour Ben Ali',
    'Sofia Rossi',
    'Incomplete registration',
    'Incomplete registration',
    'Omar Haddad',
    'Maya Chen',
  ].map((name, n) => ({
    id: 'person-' + n,
    name,
    handle:
      n === 4 || n === 5 ? null : ['amira', 'leo', 'nour', 'sofia', '', '', 'omar', 'maya'][n],
    profileId: n === 4 || n === 5 ? null : 'profile-' + n,
    registeredAt: now - ((n + 1) * day) / 2,
    completedAt: n === 4 || n === 5 ? null : now - (n * day) / 2,
    verified: n !== 4,
    status: n === 6 ? 'suspended' : n === 4 || n === 5 ? 'incomplete' : 'active',
    labAccess: n === 1,
    submittedIdeas: n < 4 ? 2 : 0,
    votesCast: n < 4 ? 3 : 0,
    wins: n < 4 ? 1 : 0,
  }));
  const titles = [
    'The Last Train',
    'Room 407',
    'Letters to Tomorrow',
    'A Quiet Revolution',
    'The Other Side',
    'Borrowed Time',
    'Second Sunrise',
    'The Glass Orchard',
    'Under the Same Sky',
    'A Small Fortune',
    'Withdrawn idea',
    'Removed idea',
  ];
  const ideas: C.CommunityIdea[] = titles.map((title, n) => ({
    id: 'idea-' + n,
    title,
    premise:
      n === 11
        ? ''
        : 'An unexpected encounter changes the lives of two strangers, and the city they call home.',
    genre: ['Drama', 'Mystery', 'Romance', 'Comedy'][n % 4],
    status: n < 7 ? 'winner' : n === 10 ? 'withdrawn' : n === 11 ? 'archived' : 'active',
    removed: n === 11,
    createdAt: now - ((n + 1) * day) / 2,
    points: n === 11 ? null : 34 - n * 2,
    supporters: n === 11 ? null : 19 - n,
    sessionVotes: n === 11 ? null : 12 - n,
    creator: people[n % 4],
  }));
  const empty: C.CommunityProduction = {
    entitlementId: null,
    producer: null,
    projectId: null,
    seriesTitle: null,
    deadline: null,
    submittedAt: null,
    productionStarted: false,
    stage: 'none',
    problem: null,
    productionApproved: false,
    publicationState: null,
  };
  const stages: C.ProductionStage[] = [
    'expired',
    'planning',
    'blocked',
    'running',
    'review',
    'published',
    'available',
  ];
  const sessions: C.CommunitySession[] = stages.map((stage, n) => ({
    id: 'session-' + n,
    startsAt: now - (n + 2) * 7 * day,
    endsAt: now - ((n + 1) * day) / 2,
    selectedAt: now - ((n + 1) * day) / 2,
    status: 'closed',
    winner: ideas[n],
    problem: null,
    production: {
      ...empty,
      entitlementId: 'entitlement-' + n,
      producer: people[(n + 1) % 4],
      projectId: ['planning', 'blocked', 'running', 'review', 'published'].includes(stage)
        ? (projectId ?? null)
        : null,
      seriesTitle: titles[n],
      deadline: stage === 'expired' ? now - day : now + 5 * day,
      productionStarted: ['blocked', 'running', 'review', 'published'].includes(stage),
      submittedAt: ['blocked', 'running', 'review', 'published'].includes(stage) ? now - day : null,
      stage,
      problem: stage === 'blocked' ? 'Production paused · allowance exhausted' : null,
      productionApproved: stage === 'review' || stage === 'published',
      publicationState: stage === 'review' ? 'pending' : stage === 'published' ? 'published' : null,
    },
  }));
  sessions.push({
    id: 'session-empty',
    startsAt: now - 28 * day,
    endsAt: now - 21 * day,
    selectedAt: now - 21 * day,
    status: 'closed',
    winner: null,
    production: empty,
    problem: null,
  });
  const participation = people.slice(0, 4).flatMap((p, n) =>
    [0, 1, 2].map((j) => ({
      userId: p.id,
      ideaId: ideas[(n + j) % ideas.length].id,
      at: now - ((j + 1) * day) / 2,
    })),
  );
  const moderation: C.CommunityModeration[] = [
    {
      id: 'release-1',
      kind: 'publications',
      title: 'Room 407 · The visitor',
      text: 'Episode 1 is ready for a public release review.',
      createdAt: now - day / 3,
      state: 'pending',
      creator: people[1],
      masterId: 'sample-master',
      version: 2,
      projectId: projectId ?? null,
      targetId: 'release-1',
      targetKind: 'publication',
      targetPerson: people[1],
    },
    {
      id: 'comment-1',
      kind: 'comments',
      title: 'Comment review',
      text: 'The ending left me thinking about the first scene. Beautiful work.',
      createdAt: now - day / 4,
      state: 'pending',
      creator: people[2],
      masterId: null,
      version: null,
      projectId: null,
      targetId: 'comment-1',
      targetKind: 'comment',
      targetPerson: people[2],
    },
    {
      id: 'report-1',
      kind: 'reports',
      title: 'Reported idea',
      text: 'Possible copied premise.\n\nThe Other Side — An unexpected encounter changes two lives.',
      createdAt: now - day / 5,
      state: 'open',
      creator: people[3],
      masterId: null,
      version: null,
      projectId: null,
      targetId: 'idea-4',
      targetKind: 'idea',
      targetPerson: people[0],
    },
  ];
  const overview: C.CommunityOverview = {
    serverNow: now,
    period: '7',
    counts: { registrations: 8, ideas: 12, voters: 4, awaiting: 3 },
    current: {
      id: 'current',
      startsAt: now - 3 * day,
      endsAt: now + 4 * day,
      status: 'open',
      problem: null,
      voters: 4,
      votes: 12,
      eligible: 3,
    },
    leaders: ideas.slice(7, 10),
    config: {
      enabled: true,
      durationMs: 7 * day,
      trendingWindowMs: day,
      winnerAllowance: 2000000,
      nextStartsAt: null,
      nextEndsAt: null,
    },
    attention: { expired: 1, notStarted: 2, blocked: 1, moderation: 3 },
  };
  const manual: C.CommunityIdea = {
    id: 'idea-manual',
    title: 'A Separate Chapter',
    premise: 'A production assigned outside voting.',
    genre: 'Mystery',
    status: 'winner',
    removed: false,
    createdAt: now - day,
    points: null,
    supporters: 0,
    sessionVotes: 0,
    creator: people[2],
  };
  ideas.push(manual);
  const opportunities: C.CommunityOpportunity[] = [
    {
      id: 'manual-opportunity',
      idea: manual,
      production: {
        ...empty,
        entitlementId: 'manual-opportunity',
        producer: people[2],
        deadline: now - day,
        stage: 'expired',
      },
    },
  ];
  for (const p of people) {
    p.submittedIdeas = ideas.filter((i) => i.creator?.id === p.id).length;
    p.votesCast = participation.filter((v) => v.userId === p.id).length;
    p.wins = sessions.filter((s) => s.winner?.creator?.id === p.id).length;
  }
  return {
    opportunities,
    people,
    ideas,
    sessions,
    participation,
    moderation,
    overview,
    empty,
    decisions: {} as Record<string, C.CommunityDecision[]>,
    assignments: {} as Record<string, C.CommunityDecision[]>,
    allowances: {} as Record<
      string,
      { cap: number; spent: number; reserved: number; active: boolean }
    >,
  };
}
